import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var WeatherIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#weather-1__a)",
                            children: [
                                _jsx("path", {
                                    d: "M19.94 22.31h-8.12c-.46.03-.97-.04-1.45-.22a3.779 3.779 0 01-2.18-2.05c-.21-.47-.31-.98-.31-1.5s.1-1.02.31-1.5c.2-.48.5-.9.88-1.25s.81-.62 1.3-.8c.39-.14.8-.22 1.21-.23.29-.7.75-1.32 1.35-1.79 1.62-1.31 4.12-1.3 5.73 0 .59.48 1.05 1.1 1.35 1.79.41 0 .82.08 1.21.22.49.17.93.44 1.31.8.38.36.68.78.89 1.26.21.48.31.98.31 1.5s-.11 1.03-.31 1.51c-.21.48-.5.9-.89 1.26a3.763 3.763 0 01-2.57 1.02l-.02-.02zm-.19-2.01c.31.02.56-.01.79-.1.23-.09.44-.21.62-.38s.32-.37.42-.59c.1-.23.15-.46.15-.71 0-.25-.05-.48-.15-.71-.1-.23-.24-.43-.42-.59-.18-.17-.39-.29-.62-.38a1.75 1.75 0 00-.72-.1h-.44c-.5.05-.97-.28-1.08-.78-.12-.57-.44-1.09-.9-1.45-.91-.73-2.31-.73-3.22 0-.45.37-.77.88-.9 1.45-.11.5-.58.84-1.08.78h-.43c-.25-.02-.48.02-.71.1-.23.08-.44.21-.61.38-.18.17-.32.36-.41.59-.1.23-.15.46-.15.71 0 .25.05.48.15.71.1.22.24.42.41.59a1.725 1.725 0 001.32.48h7.98z"
                                }),
                                _jsx("path", {
                                    d: "M5.96 16.57c-.15 0-.3-.03-.45-.11a8.224 8.224 0 01-3.2-2.85A8.176 8.176 0 011 9.53a8.1 8.1 0 01.94-4.18 8.161 8.161 0 012.93-3.13A8.209 8.209 0 018.98 1c1.45-.03 2.89.32 4.16 1.03s2.33 1.74 3.06 3c.47.8.8 1.68.98 2.58.35-.11.72-.19 1.09-.22.93-.08 1.85.09 2.67.51a4.95 4.95 0 012.01 1.84c.49.79.74 1.69.74 2.62 0 .55-.45 1-1 1s-1-.45-1-1-.15-1.1-.45-1.57c-.3-.47-.71-.85-1.2-1.1-.5-.25-1.05-.36-1.6-.3-.55.05-1.08.25-1.52.58-.3.23-.71.27-1.05.09a1 1 0 01-.55-.89c0-1.1-.29-2.18-.85-3.12a6.041 6.041 0 00-2.31-2.26 6.28 6.28 0 00-3.14-.78c-1.1.02-2.17.34-3.1.92-.93.58-1.7 1.39-2.21 2.36A6.19 6.19 0 003 9.45c.05 1.1.39 2.16.99 3.08.6.92 1.43 1.66 2.41 2.15.49.25.69.85.45 1.34-.18.35-.53.55-.9.55h.01z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "weather-1__a",
                                children: _jsx("path", {
                                    transform: "translate(1 1)",
                                    d: "M0 0h22.72v21.31H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
WeatherIcon.isCarinaIcon = true;
export default WeatherIcon;
